import React, { useState } from "react";
import { Preview } from "react-dnd-multi-backend";
import { DragSource, DropTarget } from "react-dnd";
import { Spin, Icon } from "antd";
import styles from "./ImageCard.scss";
import ImageDragPreview from "./ImageDragPreview";
import { getIconUrl } from "../../../../../services/asset";
import { UploadStatus } from "../../../../../models/enums";

const DRAG_DROP_TYPE = "image";


interface ImageCardProps {
  className: string;
  connectDragSource: any;
  connectDropTarget: any;
  disabled: boolean;
  draggable: boolean;
  imageUrl: string;
  index: number;
  isOver: boolean;
  onMove: (fromIndex: number, toIndex: number) => void;
  onPreview: (x: string) => void;
  onRemove: (index: number) => void;
  status: string;
}

const ImageCard = (props: ImageCardProps) => {
  const {
    className,
    status,
    imageUrl,
    isOver,
    onPreview,
    connectDragSource,
    connectDropTarget
  } = props;

  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
  };

  const handleDeleteClick = e => {
    const { index, onRemove } = props;
    onRemove(index);
    e.stopPropagation();
  };

  const renderImage = () => {
    const { imageUrl, status } = props;
    if (error || status === UploadStatus.error) {
      return (
        <div className={styles.error}>
          {"Greška"}
        </div>
      );
    }

    return <img alt={imageUrl} src={imageUrl} onErrorCapture={handleError} />;
  };

  const renderHoverMenu = () => {
    const { disabled } = props;
    if (disabled) {
      return null;
    }

    return (
      <div className={styles.hoverMenu}>
        <img
          role="presentation"
          alt="delete"
          src={getIconUrl("delete-icon.svg")}
          className={styles.deleteButton}
          onClick={handleDeleteClick}
        />
      </div>
    );
  };

  return connectDropTarget(
    connectDragSource(
      <div className={`${styles.imageCardWrapper} ${className}`}>
        <Preview
          generator={({ style, item }) => (
            <ImageDragPreview style={style} item={item} />
          )}
        />
        <span
          className={`${styles.imageCard} ${isOver ? styles.dragingCard : ""}`}
          tabIndex={-1}
          role="button"
          onClick={() => error || status === UploadStatus.error ? null : onPreview(imageUrl)}
        >
          {status !== UploadStatus.uploading ? (
            <React.Fragment>
              {renderImage()}
              {renderHoverMenu()}
            </React.Fragment>
          ) : (
            <div className={styles.loadingCard}>
              <Spin indicator={<Icon type="loading-3-quarters" spin />} />
            </div>
          )}
        </span>
      </div>
    )
  );
};

ImageCard.defaultProps = {
  className: "",
  disabled: false,
  draggable: true,
  imageUrl: null
};

export default DropTarget(
  DRAG_DROP_TYPE,
  {
    canDrop() {
      return true;
    },
    drop(props: ImageCardProps, monitor) {
      const item = monitor.getItem();
      props.onMove(item.index, props.index);
    }
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)(
  DragSource(
    DRAG_DROP_TYPE,
    {
      beginDrag(props: ImageCardProps) {
        return { index: props.index, imageUrl: props.imageUrl };
      },
      canDrag(props) {
        const { status, draggable, disabled } = props;
        return status !== UploadStatus.uploading && draggable && !disabled;
      }
    },
    connect => ({
      connectDragSource: connect.dragSource()
    })
  )(ImageCard)
);



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/MultiplePhotos/ImageCard/index.tsx